import infoStyle from "./info.module.css"
import managerStyle from "manager/manager.module.css"

import { useOffcanvas } from "offcanvas/provider"
import { useLayoutEffect, useState } from "react"

import { status_info } from "../data"


export default function StatusInfo(props) {

    const { offcanvas_close } = useOffcanvas()

    const gradeList = window.EventManager.gradeList

    const user_id = props['user_id']

    const [studentName, Set_studentName] = useState('')
    const [parentPhone, Set_parentPhone] = useState('')
    const [studentGrade, Set_studentGrade] = useState('')
    const [address, Set_address] = useState('')
    const [responseList, Set_responseList] = useState([])

    useLayoutEffect(() => {
        get_info()
    }, [user_id])

    async function get_info() {
        const data = await status_info({
            user_id: user_id
        })

        Set_studentName(data['studentName'])
        Set_parentPhone(data['parentPhone'])
        Set_studentGrade(data['studentGrade'])
        Set_address(data['address'])
        Set_responseList(data['UserResponses'])
    }

    return(
        <div className={infoStyle['infoWrap']}>
            <div
                style={{
                    width: "100%",
                    height: "calc(100% - 30px)",
                    overflowX: "hidden",
                    overflowY: "auto"
                }}
            >
                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>이름</label>
                    <div className={infoStyle['value']}>{studentName}</div>
                </div>

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>연락처</label>
                    <div className={infoStyle['value']}>{parentPhone}</div>
                </div>

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>학년</label>
                    <div className={infoStyle['value']}>
                        {function() {
                            const grade = gradeList.find(x => x['Mcode'].trim() === studentGrade)
                            if(grade) {
                                return grade['McodeName']
                            }
                            else {
                                return ''
                            }
                        }()}
                    </div>
                </div>

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>주소</label>
                    <div className={infoStyle['value']}>{address}</div>
                </div>

                {responseList
                .map((value, index) => {
                    return(
                        <div
                            key={index}
                            className={infoStyle['block']}
                        >
                            <label className={infoStyle['label']}>{value['label']}</label>
                            <div className={infoStyle['value']}>{value['value']}</div>
                        </div>
                    )
                })}
            </div>

            <button
                type="button"
                className={`
                    ${managerStyle['button']}
                    ${managerStyle['secondary']}
                `}
                style={{
                    position: "absolute",
                    bottom: "0px",
                    width: "100%",
                    height: "30px"
                }}
                onClick={offcanvas_close}
            >닫기</button>
        </div>
    )
}